import { render } from "./LogoutLogo.vue?vue&type=template&id=29e4c84c"
import script from "./LogoutLogo.vue?vue&type=script&lang=js"
export * from "./LogoutLogo.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__